export default __webpack_public_path__ + "images/ea63b50edea2710f3918cd3d5615e67f-alumni.jpg";